/* eslint-disable import/first */
import React from 'react';
import { Grid } from '@material-ui/core';
import { numberWithSpaces, allowedCountry } from 'spwa-ui-library/esm/utils/helper';

import css from './index.module.scss';
import uaeIcon from '../../components/SideMenu/images/uae.png';
import bhrIcon from '../../components/SideMenu/images/bahrain.png';
import egpIcon from '../../components/SideMenu/images/egypt.png';
import kuwaitIcon from '../../components/SideMenu/images/kuwait.png';
import omIcon from '../../components/SideMenu/images/oman.jpg';
import ksaIcon from '../../components/SideMenu/images/ksa.jpg';
import qtrIcon from '../../components/SideMenu/images/qatar.png';
export const countryList = [
  { name: 'United Arab Emirates', code: 'UAE', flag: uaeIcon },
  { name: 'Bahrain', code: 'BHR', flag: bhrIcon },
  { name: 'Egypt', code: 'EGY', flag: egpIcon },
  { name: 'Kuwait', code: 'KWT', flag: kuwaitIcon },
  { name: 'Oman', code: 'OMN', flag: omIcon },
  { name: 'Jordan', code: 'JON', flag: omIcon },
  { name: 'Qatar', code: 'QAT', flag: qtrIcon },
  { name: 'Saudi Arabia', code: 'KSA', flag: ksaIcon },
];

const ViewProfileCard = ({ profile }) => {
  return (
    <Grid className={css.profileCardArea}>
      <Grid className={css.innerProfileCard}>
        <Grid>
          <Grid className={css.circleArea}>
            {profile.data.data?.[0].name.charAt(0).toUpperCase()}
          </Grid>
        </Grid>
        <Grid className={css.profileTextArea}>
          <Grid className={css.profileName}>{profile.data.data?.[0].name}</Grid>
          <Grid className={css.profileEmail}>{profile.data.data?.[0].email}</Grid>
        </Grid>
      </Grid>
      <Grid>
        <Grid className={css.profilePhone}>
          {profile?.data?.data?.map((each) => {
            let country = countryList.find(({ code }) => code === each.country);
            const isAllowCountry =
              allowedCountry(each.country) && each.country === profile.country;
            if (!each.phnNo || !isAllowCountry) return '';
            return (
              <span className={css.profilePhoneStyle}>
                <img width="28" height="20" src={country.flag} alt="flag" /> {each.cCode} -{' '}
                {each.phnNo && numberWithSpaces(each.phnNo, '### ### ### ###')}
              </span>
            );
          })}
        </Grid>        
      </Grid>
    </Grid>
  );
};
export default ViewProfileCard;
